import React from 'react'
import { Helmet } from 'react-helmet';
import { NavLink } from "react-router-dom";

const Home = () => {
    return (
        <div className='main-container'>
            <Helmet>
                <title>Geoportal of Indian Dams</title>
            </Helmet>
            <header id="head">
                <div className="banner-content">
                <h2>Welcome to</h2>
                    <h1>Geoportal of Indian Dams (GeoID)</h1>
                    <h3>Catchment Parameters and Projected Flood Risk of Indian Dams.</h3>
                </div>
                <button className="VisitButton"><NavLink to="/dams"><span>Map Viewer </span></NavLink></button>
            </header>




        </div>

    )
}

export default Home
